<template>
  <div>
    <v-menu
      v-model="menu"
      class="pt-0"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="dateRangeText"
          label="Rango de fechas"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          outlined
          dense
        ></v-text-field>
      </template>
      <v-date-picker
        :first-day-of-week="1"
        v-model="dates"
        @change="updateDates"
        range
        locale="es"
        no-title
        scrollable
      >
      </v-date-picker>
    </v-menu>

    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
  </div>
</template>

<script>
import moment from "moment";
import Loader from "@/components/common/Loader";

export default {
  name: "DatePickerRange",
  components: { Loader },
  props: ["substract1month"],
  data() {
    return {
      menu: false,
      dates: this.substract1month
        ? [
            moment()
              .subtract(1, "month")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ]
        : [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      dialogLoader: true
    };
  },
  computed: {
    dateRangeText() {
      return this.dates?.join(" ~ ");
    }
  },
  mounted() {
    this.updateDates(this.dates);
  },
  methods: {
    updateDates(dates) {
      this.dialogLoader = true;
      this.$emit("updateDates", dates);
      setTimeout(() => {
        this.dialogLoader = false;
      }, 2000);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
